module.exports = __webpack_public_path__ + "static/nate-davis-resume-2021-c38a8e6c177a7d9b7d47acd269448c74.pdf";